import React from "react";

// Unique inline SVG logo for Ecominiere.
// Concept: two overlapping arches evoking Italian arches / brick, forming an
// upward-pointing shape (growth), inside a soft rounded square.
export default function Logo({ compact = false, className = "" }) {
  return (
    <span className={`ec-logo ${className}`} aria-label="Ecominiere">
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect x="1" y="1" width="34" height="34" rx="10" fill="#0B2A2A" />
        <path
          d="M9 25V16a5 5 0 0 1 10 0v9"
          stroke="#E7C46A"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        <path
          d="M17 25V14a5 5 0 0 1 10 0v11"
          stroke="#F4F1EA"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        <circle cx="27" cy="11" r="1.6" fill="#E7C46A" />
      </svg>
      {!compact && <span className="ec-logo-text">Ecominiere</span>}
    </span>
  );
}
